import Phaser from 'phaser';
import { getGameHeight } from '../config/constants';

/**
 * Enable mouse-wheel and touch-drag scrolling on a container whose content
 * exceeds the visible viewport. No-ops if contentHeight fits on screen.
 */
export function enableScrolling(
  scene: Phaser.Scene,
  container: Phaser.GameObjects.Container,
  contentHeight: number,
): { isDragging: () => boolean } {
  const state = { _isDragging: false };

  if (contentHeight <= getGameHeight()) return { isDragging: () => false };

  let scrollY = 0;
  const maxScroll = contentHeight - getGameHeight() + 40;

  scene.input.on('wheel', (_pointer: Phaser.Input.Pointer, _gameObjects: Phaser.GameObjects.GameObject[], _deltaX: number, deltaY: number) => {
    scrollY = Phaser.Math.Clamp(scrollY + deltaY * 0.5, 0, maxScroll);
    container.setY(-scrollY);
  });

  let dragStartY = 0;
  let containerStartY = 0;
  scene.input.on('pointerdown', (pointer: Phaser.Input.Pointer) => {
    dragStartY = pointer.y;
    containerStartY = container.y;
    state._isDragging = false;
  });
  scene.input.on('pointermove', (pointer: Phaser.Input.Pointer) => {
    if (!pointer.isDown) return;
    const dy = dragStartY - pointer.y;
    if (Math.abs(dy) > 20) {
      state._isDragging = true;
      scrollY = Phaser.Math.Clamp(-containerStartY + dy, 0, maxScroll);
      container.setY(-scrollY);
    }
  });

  return { isDragging: () => state._isDragging };
}
